import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id", "for"]
const _hoisted_2 = ["type", "id", "value"]
const _hoisted_3 = { class: "label" }
const _hoisted_4 = {
  key: 0,
  class: "error-color font-small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("label", {
    id: 'label-' + _ctx.nameInput,
    for: _ctx.nameInput,
    class: _normalizeClass({'form-input-error': !_ctx.msg.state, 'form-input': _ctx.msg.state})
  }, [
    _createElementVNode("input", {
      class: "input-default-style font-medium font-weight-400",
      type: _ctx.dataType,
      id: _ctx.nameInput,
      placeholder: " ",
      value: _ctx.data,
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:data', $event.target.value)))
    }, null, 40, _hoisted_2),
    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.placeholder), 1),
    (!_ctx.msg.state)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.msg.message)), 1))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}